import React from 'react';
import { usePromiseTracker } from "react-promise-tracker";
import { clone } from 'numeral';
import { CircularProgress, LinearProgress, Box } from '@mui/material';

const LoadingIndicator = props => {
    return (
        <>
            {props.isFileLoader && <div className="modal fade-in" style={{ display: 'block', top: 10 }}>
            <Box sx={{ width: '100%' }}>
                <LinearProgress />
            </Box>
                            {/* <div
                                style={{
                                    width: "100%",
                                    height: "100",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}>
                                {props.isFileLoader && 
                                <CircularProgress height={36} width={36} value={70}/>
                                } 
                            </div> */}
                        </div>
                        }
        </>
    )
};

export default LoadingIndicator;

// import React from 'react';
// import { usePromiseTracker } from "react-promise-tracker";
// import { LinearProgress } from '@mui/material';

// const LoadingIndicator = props => {
    
//     return <div className="modal fade-in" style={{ position: 'fixed', display: 'flex', top: 90, width: 50, height: 'auto', left: 'calc(50% - 25px)' }}>
//         <div
//             style={{
//                 height: 33,
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center"
//             }}>
//             <LinearProgress value={props?.progress} height={30} width={50} />
//         </div>
//     </div>
// };

// export default LoadingIndicator;
